<template>
  <div class="row">
    <div class="col-md-12">
      <div class="m-portlet m-portlet--tab">
        <div class="m-portlet__body">
          <span class="lsoading-request" v-show="loading"></span>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
          >
            <h1 class="h2">Gerar faturas</h1>
          </div>

          <div
            id="alert"
            class="alert alert-dismissible fade show m-alert m-alert--outline mb-5 mt-4"
            :class="alert.color"
            role="alert"
            v-if="alert.message"
          >
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="alert.message = ''"
            ></button>
            <i :class="alert.icon"></i> &nbsp;<strong>{{
              alert.message
            }}</strong
            ><br />
            {{ alert.reason }}
          </div>

          <div class="row mb-3">
            <div class="col-md-6">
              <label for="billing_month"
                >Referente ao mês (mm/yyyy)
                <span class="m--font-danger">*</span></label
              >
              <div class="input-group">
                <InputBillingMonth
                  ref="billing_month"
                  v-model="data.billing_month"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="col-md-12">
                <label for="companies_month"> Clientes </label>
                <SelectCustomersMultiple @selected="selectedCustomer" />
              </div>
            </div>
          </div>

          <hr class="row mt-5 mb-3" />
          <div class="row">
            <div class="col-md-12 text-right">
              <p class="p-0 m-0">
                <a
                  href="#"
                  @click.prevent="$refs.billing_month.focus()"
                  target="_self"
                  class="m--font-danger"
                  v-if="!data.billing_month"
                  >O campo <strong>Referente ao mês</strong> é obrigatório *</a
                >
              </p>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-6">
              <label for="note">Planilha</label>
              <div class="input-group">
                <input
                  accept=".csv"
                  type="file"
                  class="form-control"
                  name="file"
                  ref="fileInput"
                  @change="chooseFile"
                />
              </div>
            </div>
            <div class="col-md-6 d-flex justify-content-left align-items-end">
              <button
                type="button"
                @click.prevent="downloadSpreadsheetModel($event)"
                class="btn btn-focus mr-2"
              >
                <i class="fas fa-solid fa-download"></i>
                Baixar Modelo
              </button>
              <button
                type="button"
                @click.prevent="cleasSpreadsheetModel($event)"
                class="btn btn-focus mr-2"
              >
                <i class="fas fa-solid fa-eraser"></i>
                Limpar
              </button>
            </div>
          </div>
          <div class="row mb-5">
            <div class="col-md-12 text-right">
              <button
                class="btn"
                :class="{
                  'btn-metal': !formIsValid,
                  'btn-focus': formIsValid,
                }"
                :disabled="!formIsValid || loading"
                @click="process"
              >
                <i class="fas fa-chevron-circle-sync" v-if="formIsValid"></i>
                <i class="fas fa-exclamation-triangle" v-else></i>
                Gerar
              </button>
            </div>
          </div>

          <div class="tab-content">
            <div class="tab-pane active" id="save_contract" role="tabpanel">
              <form name="contract" class="needs-validation" novalidate>
                <hr class="row mt-5 mb-3" />
              </form>
            </div>
          </div>
          <hr class="row mb-3" />
          <ProcessInvoiceHistory />
        </div>
      </div>
    </div>
    <div class="row">
      <transition name="slideleft" mode="out-in">
        <InvoiceGenerateCsv v-if="showInvoiceGenerateCsv" />
      </transition>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showInvoiceGenerateCsv"
          @click="closeInvoiceGenerateCsv()"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';
import ProcessInvoiceHistory from '@/components/invoices/ProcessInvoiceHistory';
import InvoiceGenerateCsv from '@/components/invoices/InvoiceGenerateCsv';
import SelectCustomersMultiple from '@/components/forms/SelectCustomersMultiple';
import InputBillingMonth from '@/components/forms/InputBillingMonth';
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageFormMixin],
  components: {
    ProcessInvoiceHistory,
    SelectCustomersMultiple,
    InvoiceGenerateCsv,
    InputBillingMonth,
  },
  name: 'GenerateInvoices',
  data() {
    return {
      data: {
        billing_month: '',
        customers: '',
        file: {
          selected: false,
        },
      },
      isFileSelected: false,
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      loading: false,
    };
  },
  computed: {
    showInvoiceGenerateCsv() {
      return this.$store.state.showInvoiceGenerateCsv;
    },
    formIsValid() {
      if (this.data.billing_month) {
        return true;
      }
      return false;
    },
  },
  methods: {
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    process() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Enviando requisição...',
        reason: '',
      };

      const formData = new FormData();
      formData.append('file', this.isFileSelected ? this.data.file : 0);
      formData.append('customers', this.data.customers);
      formData.append('billing_month', this.data.billing_month);

      this.loading = true;
      const url = `${baseApiUrl}/v1/invoice/process`;
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };
      axios
        .post(url, formData, config)
        .then((res) => {
          this.logMessageForm(res);
          this.loading = false;
        })
        .catch((error) => {
          this.logMessageFormFailed(error.response);
          this.loading = false;
        });
    },
    validateCustomersIds($event) {
      if (!Number.isNaN($event.key) || $event.key === ',') {
        return true;
      }
      $event.preventDefault();
      return false;
    },
    selectedCustomer(customersId) {
      this.data.customers = customersId.join(',');
    },
    openInvoiceGenerateCsv(id) {
      this.$store.state.showInvoiceGenerateCsv = id;
    },
    closeInvoiceGenerateCsv() {
      this.$store.state.showInvoiceGenerateCsv = null;
    },
    cleasSpreadsheetModel() {
      this.$refs.fileInput.value = null;
      this.isFileSelected = false;
      this.data.file = {
        selected: false,
      };
    },
    downloadSpreadsheetModel() {
      this.downloading = true;
      const url = `${baseApiUrl}/v1/invoice/download-model`;

      axios(url)
        .then((res) => {
          const arrData = res.data;

          let csvContent = 'data:text/csv;charset=utf-8,';
          csvContent += [
            Object.keys(arrData[0]).join(';'),
            ...arrData.map((item) => String(Object.values(item).join(';'))),
          ]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');

          link.setAttribute('href', data);

          let fileName = `modelo`;

          if (this.start) {
            fileName += `_${this.start}-${this.finish}`;
          }

          fileName = `${fileName}.csv`;

          link.setAttribute('download', fileName);

          link.click();
          this.downloading = false;
        })
        .catch((error) => {
          console.log(error);
          this.downloading = false;
        });
    },
    chooseFile(e) {
      this.data.file = e.target['files'][0];
      this.isFileSelected = true;
    },
  },
};
</script>
